import { render, staticRenderFns } from "./CartList.vue?vue&type=template&id=1a015311&scoped=true&lang=pug"
import script from "./CartList.vue?vue&type=script&lang=js"
export * from "./CartList.vue?vue&type=script&lang=js"
import style0 from "./CartList.vue?vue&type=style&index=0&id=1a015311&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a015311",
  null
  
)

export default component.exports